/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
// eslint-disable-next-line no-nested-ternary
import React from "react";
import PropTypes from "prop-types";
import EmailIcon from "../../assets/img/icons/icon-email.svg";
import TextIcon from "../../assets/img/icons/icon-text-message.svg";
import SlackIcon from "../../assets/img/icons/icon-slack.svg";
import PushIcon from "../../assets/img/icons/icon-smart-phone.svg";
import TriggerToName from "./TriggerToName";

function TriggerBox({ triggertype, receipients, showPanelClick, blockId }) {
  const handleOnclick = React.useCallback(() => {
    showPanelClick(blockId);
  }, [blockId, showPanelClick]);

  return (
    <div className="pp_trigger_box_holder">
      <div className="pp_trigger_box_header">
        {triggertype === "EMAIL" ? (
          <EmailIcon className="pp_trigger_box_icon" />
        ) : triggertype === "TEXT" ? (
          <TextIcon className="pp_trigger_box_icon" />
        ) : triggertype === "SLACK" ? (
          <SlackIcon className="pp_trigger_box_icon" />
        ) : triggertype === "PUSH" ? (
          <PushIcon className="pp_trigger_box_icon" />
        ) : null}
        <div className="pp_trigger_box_name">{triggertype}</div>
      </div>
      <div className="pp_trigger_hint">To:</div>
      <div className="pp_trigger_box_to_holder">
        {receipients.map(({ name }, index) => (
          <TriggerToName key={index} name={name} />
        ))}
      </div>
      <button
        type="button"
        className="pp_trigger_box_edit"
        onClick={handleOnclick}
      >
        Edit
      </button>
    </div>
  );
}

TriggerBox.propTypes = {
  triggertype: PropTypes.string.isRequired,
  blockId: PropTypes.string.isRequired,
  receipients: PropTypes.array.isRequired,
  showPanelClick: PropTypes.func.isRequired,
};

export default TriggerBox;
